import { useTranslation } from 'react-i18next'
import { BackArrowIcon, BaseError } from '../BaseError'

export function CampaignNotAuthorized({
	campaignId,
}: {
	campaignId: string
}) {
	const { t } = useTranslation('common')

	return (
		<BaseError
			errorCode={403}
			heading={t('errors.campaignNotAuthorized.heading')}
			message={
				<>
					<span>{t('errors.campaignNotAuthorized.message')}</span>
					<br />
					<span className="text-sm text-grey-500">
						{t('errors.campaignNotAuthorized.campaignId', { id: campaignId })}
					</span>
				</>
			}
			suggestions={[
				t('errors.campaignNotAuthorized.switchCompany'),
				t('errors.campaignNotAuthorized.requestAccess'),
				t('errors.campaignNotAuthorized.contactSupport'),
			]}
			actions={[
				{
					label: t('errors.campaignNotAuthorized.selectCompany'),
					ariaLabel: t('errors.campaignNotAuthorized.selectCompany'),
					to: '/company',
					icon: <BackArrowIcon />,
				},
			]}
		/>
	)
}
